module.exports = __webpack_public_path__ + "02_veryshort_gold.d37acbac.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/02_veryshort_gold.png
// module id = FksQ
// module chunks = 0